import { HAS_WHITE_SPACES } from 'common/constants/messages/validations';

/**
 * Validates a value to exclude white spaces.
 *
 * @param {string} value - The value to be validated
 * @param {object} options - Additional options for the validation.
 * @returns {string|null} - Returns a string if the value is invalid, otherwise null.
 */

/*
Based on the validate.js documentation, it passes parameters as separate arguments
rather than as a single object. That is why we are not using an interface.
*/

export const excludeWhiteSpacesValidator = (
  value: string,
  options: { message: string }
): string | null => {
  const tmpValue = value ?? '';

  const hasSpaces = /\s+/.exec(tmpValue);

  return hasSpaces ? options.message ?? HAS_WHITE_SPACES : null;
};
